/**
 * Route for `affiliate-approval`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AffiliateApprovalPage } from "../features/affiliate-approval/AffiliateApprovalPage";

export const affiliateApprovalRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliate-approval",
	component: AffiliateApprovalPage,
});

export default affiliateApprovalRoute;
